import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function fm(n) {
  return Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function exportItemsOnSaleDailyReportExcel(report, fileName) {
  if (!report) return;

  const meta = report.meta || {};
  const name =
    fileName ||
    `items-on-sale-daily-${meta.branchId}-${meta.year}-${String(meta.monthIndex + 1).padStart(2, "0")}.xlsx`;

  const summaryRows = [
    { Metric: "Month", Value: meta.monthLabel },
    { Metric: "Branch", Value: meta.branchLabel },
    { Metric: "Group filter", Value: meta.groupLabel },
    { Metric: "Working days", Value: meta.workingDayCount },
    { Metric: "Sundays excluded", Value: meta.sundayCount },
    { Metric: "Holidays excluded", Value: meta.holidayCount },
    { Metric: "Days with sales", Value: meta.grandTotals?.workingDaysWithSales ?? 0 },
    { Metric: "Distinct items sold", Value: meta.grandTotals?.itemCount ?? 0 },
    { Metric: "Total qty", Value: meta.grandTotals?.qty ?? 0 },
    { Metric: "Total amount", Value: meta.grandTotals?.amount ?? 0 },
  ];

  const holidayRows = (report.skipped?.holidays || []).map((h) => ({
    Date: h.ymd,
    Name: h.name,
  }));

  const daySummaryRows = (report.days || []).map((day) => ({
    Date: day.ymd,
    Weekday: day.weekday,
    "Item count": day.totals.itemCount,
    "Invoice count": day.totals.invoiceCount,
    Qty: day.totals.qty,
    Amount: day.totals.amount,
  }));

  const detailRows = [];
  for (const day of report.days || []) {
    for (const item of day.items) {
      detailRows.push({
        Date: day.ymd,
        Weekday: day.weekday,
        Group: item.groupName,
        "Part No": item.partNo,
        "Item name": item.itemName,
        Qty: item.qty,
        Amount: item.amount,
        "Line count": item.lineCount,
        Invoices: item.invoiceCount,
      });
    }
  }

  const wb = XLSX.utils.book_new();
  const addSheet = (title, rows) => {
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(rows.length ? rows : [{ Empty: true }]),
      title.slice(0, 31)
    );
  };

  addSheet("Summary", summaryRows);
  addSheet("Daily Summary", daySummaryRows);
  addSheet("Item Details", detailRows);
  addSheet("Holidays", holidayRows);

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([buf], { type: "application/octet-stream" }), name);
}

export function formatItemsOnSaleDayLabel(day) {
  if (!day?.ymd) return "—";
  const [y, m, d] = day.ymd.split("-").map(Number);
  const label = new Date(y, m - 1, d).toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  return label;
}

export { fm };
